export default {
  'sslCerificates.list.deleteCdn.message': 'Delete succeeded',
  'sslCerificates.list.Popconfirm.title': 'Are you sure delete this?',
  'sslCerificates.list.Popconfirm.okText': 'Yes',
  'sslCerificates.list.Popconfirm.cancelText': 'No',
  'sslCerificates.list.title': 'SSL Certificates',
  'sslCerificates.list.Create': 'Create SSL certficates',
  'sslCerificates.list.columns.title1': 'Name',
  'sslCerificates.list.columns.title2': 'options',
  'sslCerificates.list.columns.title3': 'Domains',
  'sslCerificates.list.columns.title4': 'Start time',
  'sslCerificates.list.columns.title5': 'End time',
  'sslCerificates.list.columns.title6': 'State',
  'sslCerificates.list.State.expiry': 'Expired',
  'sslCerificates.list.State.vaild': 'Active',

  'sslCerificates.list.PopoverText1': 'Edit SSL',
  'sslCerificates.list.PopoverText2': 'SSL Details',
  'sslCerificates.list.PopoverText3': 'Delete',

  'sslCerificates.create.onSubmit.message': 'Created succeeded',
  'sslCerificates.create.validatorName.message': 'Please input correct Name',
  'sslCerificates.create.validatorName.rule': 'Use 4-20 characters',
  'sslCerificates.create.validatorSSLKey.rule':
    'Must start with -----BEGIN CERTIFICATE----- and end with -----END CERTIFICATE-----',
  'sslCerificates.create.validatorSSLPrivateKey.rule':
    'Must start with  -----BEGIN PRIVATE KEY-----,  -----BEGIN RSA PRIVATE KEY----- or -----BEGIN EC PRIVATE KEY-----. Must end with corresponding -----END... footer.',
  'sslCerificates.create.step1.Form.name.name': 'Name',
  'sslCerificates.create.step1.Form.name.message': 'Please input Name!',
  'sslCerificates.create.step1.Form.sslCertificateKey.name': 'SSL certificate',
  'sslCerificates.create.step1.Form.sslCertificateKey.message': 'Please input SSL certificate!',
  'sslCerificates.create.step1.Form.privateKey.name': 'Private key',
  'sslCerificates.create.step1.Form.privateKey.message': 'Please input Private key!',
  'sslCerificates.create.step1.Form.Button': 'Create SSL certificates',
  'sslCerificates.create.SslForm.UploadText': 'Select file',

  'sslCerificates.detail.handleSave.message': 'Edit succeeded',
  'sslCerificates.detail.title1': 'Your SSL certificates',
  'sslCerificates.detail.title2': 'Associated CDN  resources',
  'sslCerificates.detail.Button.Edit': 'Edit',
  'sslCerificates.detail.Button.Cancel': 'Cancel',
  'sslCerificates.detail.Button.Save': 'Save',
};
